<div class="container">
    <div class="drawing-menu-row">
        <pcp-slide-sync-toolbar-button-pencil></pcp-slide-sync-toolbar-button-pencil>
        <pcp-slide-sync-toolbar-button-arrow></pcp-slide-sync-toolbar-button-arrow>
        <pcp-slide-sync-toolbar-button-ellipse></pcp-slide-sync-toolbar-button-ellipse>
    </div>
    <hr />
    @let isDrawingMenuOpened = isDrawingMenuOpened$ | async;
    <pcp-stroke-width
        class="drawing-menu-row"
        [ngClass]="{ hidden: !isDrawingMenuOpened }"
    ></pcp-stroke-width>
    <hr />
    <app-color-palette class="drawing-menu-row"></app-color-palette>

</div>